var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { row: "", wrap: "" } },
    [
      _c(
        "v-flex",
        { staticClass: "pr-1", attrs: { xs4: "" } },
        [
          _c(
            "v-card",
            { staticClass: "max-height elevation-1" },
            [
              _c("v-card-text", { staticClass: "card-bg-1" }, [
                _c(
                  "div",
                  { staticClass: "caption grey--text text--darken-2" },
                  [_vm._v("Analytes Measured")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "headline" },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.numberWithCommas(
                            _vm.dataSummary.analytesMeasured,
                            0
                          )
                        ) +
                        "\n          "
                    ),
                    _c("v-icon", [_vm._v("format_color_fill")]),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { staticClass: "px-1", attrs: { xs4: "" } },
        [
          _c(
            "v-card",
            { staticClass: "max-height elevation-1" },
            [
              _c("v-card-text", { staticClass: "card-bg-1" }, [
                _c(
                  "div",
                  { staticClass: "caption grey--text text--darken-2" },
                  [_vm._v("From")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "headline" },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.dataSummary.from) +
                        "\n          "
                    ),
                    _c("v-icon", [_vm._v("event")]),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { staticClass: "pl-1", attrs: { xs4: "" } },
        [
          _c(
            "v-card",
            { staticClass: "max-height elevation-1" },
            [
              _c("v-card-text", { staticClass: "card-bg-1" }, [
                _c(
                  "div",
                  { staticClass: "caption grey--text text--darken-2" },
                  [_vm._v("To")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "headline" },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.dataSummary.to) +
                        "\n          "
                    ),
                    _c("v-icon", [_vm._v("event")]),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { staticClass: "pt-2 pr-1", attrs: { xs6: "" } },
        [
          _c(
            "v-card",
            { staticClass: "max-height elevation-1" },
            [
              _c("v-card-text", { staticClass: "card-bg-1" }, [
                _c(
                  "div",
                  { staticClass: "caption grey--text text--darken-2" },
                  [_vm._v("Measurements")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "headline" },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.numberWithCommas(_vm.dataSummary.measurements, 0)
                        ) +
                        "\n          "
                    ),
                    _c("v-icon", [_vm._v("mdi-water")]),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { staticClass: "pt-2 pl-1", attrs: { xs6: "" } },
        [
          _c(
            "v-card",
            { staticClass: "max-height elevation-1" },
            [
              _c("v-card-text", { staticClass: "card-bg-1" }, [
                _c(
                  "div",
                  { staticClass: "caption grey--text text--darken-2" },
                  [_vm._v("Depth/Height Measurements")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "headline" },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.numberWithCommas(
                            _vm.dataSummary.depthMeasurements,
                            0
                          )
                        ) +
                        "\n          "
                    ),
                    _c("v-icon", [_vm._v("terrain")]),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }